import { animate, motion } from "framer-motion";
import { useEffect, useState } from "react";

interface CircularLoadingDotsProps {
  nDots: number;
  className?: string;
}
const VIEW = 100;
const CENTER = VIEW / 2;
const RADIUS_MIN = 20;
const RADIUS_MAX = 40;
const DOT_R_RATIO = 0.25; // dot radius as a fraction of orbit radius

const CircularLoadingDots: React.FC<CircularLoadingDotsProps> = ({
  nDots,
  className,
}) => {
  // States definition
  const [radius, setRadius] = useState(RADIUS_MIN);

  // Dots definition
  const dots = Array.from({ length: nDots });

  useEffect(() => {
    const controls = animate(RADIUS_MIN, RADIUS_MAX, {
      repeat: Infinity,
      repeatType: "reverse",
      duration: 3,
      ease: "easeInOut",
      onUpdate: (latest) => setRadius(latest),
    });

    return () => controls.stop();
  }, []);

  return (
    <div className={`relative w-[50px] h-[50px] ${className}`}>
      <motion.svg
        viewBox={`0 0 ${VIEW} ${VIEW}`}
        className="w-full h-full"
        animate={{ rotate: 360 }}
        transition={{ repeat: Infinity, duration: 1, ease: "linear" }}
      >
        {dots.map((_, index) => {
          const angle = (360 / dots.length) * index;
          const rad = (angle * Math.PI) / 180;
          const cx = CENTER + radius * Math.cos(rad);
          const cy = CENTER + radius * Math.sin(rad);
          const opacity = 0.25 + 0.75 * (index / dots.length);

          return (
            <circle
              key={`dot-${index}`}
              cx={cx}
              cy={cy}
              r={radius * DOT_R_RATIO}
              className="fill-secondary-500"
              opacity={opacity}
            />
          );
        })}
      </motion.svg>
    </div>
  );
};

export default CircularLoadingDots;
